import { Link } from '@/Framework/Router/Next/Link';
import type IDealCellData from '@/finsight/ui/components/deals/DealListTable/cells/types';

import styles from './parent.scss';

export const ParentCompany = ({ row: deal }: { row: IDealCellData }) => {
  const { parent, parentLink } = deal;
  return (
    parent.viewId && (
      <Link to={ parentLink } className={ styles.parentLink }>
        { parent.name }
      </Link>
    )
  );
};
